import { Product } from '@dehaat/kisan-app-bl/models/ProductV2';
import { MutableRefObject } from 'react';
import { Slug } from '@/models/Product';
import { get } from '@/utils/axios';
interface ApiResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
  brand?: RelevantSearchItem;
  category?: RelevantSearchItem;
  suggestion_list?: string[];
}
export interface RelevantSearchItem {
  app_display_name: string;
  id: number;
  image_url: string | null;
  slug_info: Slug;
}
export interface Params {
  page: number;
  page_size: number;
  vendor_id: number;
  query: string;
  isprebook: boolean;
  lang: string;
}
const fetchSearchProduct = async (url: string, params?: Partial<Params>, abortRef?: MutableRefObject<AbortController | null>): Promise<ApiResponse<Product> | null> => {
  try {
    return await get('/hyperlocal/v1/sellable/search', params, undefined, abortRef?.current?.signal);
  } catch (e) {
    console.error(e);
  }
  return null;
};
export default fetchSearchProduct;